import { createContext, useContext } from 'react';

const GoBackContext = createContext();

export const useGoBackContext = () => useContext(GoBackContext);

export default GoBackContext;
